var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09294 0C3.1815 0 0 3.1815 0 7.09294C0 11.0044 3.1815 14.1859 7.09294 14.1859C11.0044 14.1859 14.1859 11.0044 14.1859 7.09294C14.1859 3.1815 11.0044 0 7.09294 0ZM7.09294 11.3491C4.74565 11.3491 2.83675 9.44023 2.83675 7.09294C2.83675 4.74565 4.74565 2.83675 7.09294 2.83675C9.44023 2.83675 11.3491 4.74565 11.3491 7.09294C11.3491 9.44023 9.44023 11.3491 7.09294 11.3491Z",
    fill: "#EE1A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4215 9.95307C11.7854 9.95307 12.1472 10.0914 12.4238 10.3681L16.6332 14.5774C17.1865 15.1307 17.1865 16.0288 16.6332 16.5842C16.0799 17.1397 15.1819 17.1375 14.6264 16.5842L10.417 12.3748C9.86374 11.8215 9.86374 10.9235 10.417 10.3681C10.6958 10.0935 11.0576 9.95307 11.4215 9.95307Z",
    fill: "#EE1A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fe49ab06b122149f15e3723453c107f8.svg";
export { ForwardRef as ReactComponent };